<script setup>
import { computed } from 'vue';
import { useMessageFormatter } from 'shared/composables/useMessageFormatter';

const props = defineProps({
  config: {
    type: Object,
    default: () => ({}),
  },
});

const { formatMessage } = useMessageFormatter();

const isDefaultScreen = computed(() => {
  return (
    props.config.isDefaultScreen &&
    ((props.config.welcomeHeading &&
      props.config.welcomeHeading.length !== 0) ||
      (props.config.welcomeTagLine &&
        props.config.welcomeTagline.length !== 0) ||
      props.config.welcomeDisclaimer)
  );
});

const formattedDisclaimer = computed(() => {
  return formatMessage(props.config.welcomeDisclaimer, false, false);
});
</script>

<template>
  <div
    class="flex-shrink-0 transition-[max-height] duration-300"
    :class="isDefaultScreen ? 'px-4 py-5' : 'p-4'"
    :style="{
      background: 'var(--wt-banner-bg, ' + config.color + ')',
      borderRadius:
        'var(--wt-border-radius, 8px) var(--wt-border-radius, 8px) 0 0',
    }"
  >
    <div class="relative top-px">
      <div class="flex items-center justify-start">
        <img
          v-if="config.logo"
          :src="config.logo"
          class="mr-2 rounded-full logo"
          :class="!isDefaultScreen ? 'h-8 w-8 mb-1' : 'h-12 w-12 mb-2'"
        />
        <div v-if="!isDefaultScreen">
          <div class="flex items-center justify-start gap-1">
            <span
              class="text-base font-medium leading-3"
              :style="{ color: 'var(--wt-banner-text, #ffffff)' }"
            >
              {{ config.websiteName }}
            </span>
            <div
              v-if="config.isOnline"
              class="w-2 h-2 bg-n-teal-10 rounded-full"
            />
          </div>
          <span class="mt-1 text-xs text-n-slate-11">
            {{ config.replyTime }}
          </span>
        </div>
      </div>
      <div v-if="isDefaultScreen" class="overflow-auto max-h-60">
        <h2
          class="text-3xl leading-8 font-semibold opacity-75 mb-2"
          :style="{ color: 'var(--wt-banner-text, #ffffff)' }"
        >
          {{ config.welcomeHeading }}
        </h2>
        <p
          class="text-xl leading-6 font-semibold"
          :style="{ color: 'var(--wt-banner-text, #ffffff)' }"
        >
          {{ config.welcomeTagline }}
        </p>
        <div
          v-if="config.welcomeDisclaimer"
          class="header-disclaimer text-xs opacity-75"
          :style="{ color: 'var(--wt-banner-text, #ffffff)' }"
          v-html="formattedDisclaimer"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header-disclaimer {
  a {
    color: var(--white);
    text-decoration: underline;
  }
}
</style>
